import { useLogin } from "../login/context/LoginContext";

import { Button } from '@ui-component-library';
import { TailwindWrapper } from "@utils/TailwindWrapper";

import LoginStart from './content/start';
import LoginBankid from './content/bankid';
import LoginCode from './content/code';
import LoginMain from './content/main';

import TreebulaLogo from '@assets/treebula/logo.svg';

export default function LoginPopup({children}) {
    const LoginContext = useLogin();

    return <>
        {LoginContext.show && <TailwindWrapper>
            <div className='flex flex-col fixed inset-0 w-screen h-svh bg-white p-4' style={{ zIndex: 10000 }}>
                <div className='flex justify-between mb-4'>
                    <TreebulaLogo width='200px' className='cursor-pointer' onClick={() => window.location.pathname == '/' ? LoginContext.close(false) : window.open('/', '_self')} />
                    <Button tw variant='secondary' onClick={() => LoginContext.close(false)}>Stäng</Button>
                </div>
                
                <div className='flex flex-col flex-grow items-center md:justify-center justify-start md:bg-stone-50 bg-cloud-50 md:rounded-4xl mt-6'>
                    <div style={{width: '100%', maxWidth: '450px'}}>
                        {LoginContext.view == 'start' && <LoginStart />}
                        {LoginContext.view == 'bankid' && <LoginBankid />}
                        {LoginContext.view == 'code' && <LoginCode />}
                        {LoginContext.view == 'main' && <LoginMain />}
                    </div>
                </div>
            </div>
        </TailwindWrapper>}

        {children}
    </>
}

/*

<div style={{maxWidth: '450px'}}>

*/